import { Row } from "reactstrap";
import DashboardGroup, { DashboardGroupProps } from "./DashboardGroup";
import { getClaims } from "../../utility/tokenHelper";

const groups: DashboardGroupProps[] = [
  {
        title: "ExxonMobil Baton Rouge Complex",
    items: [
      {
        title: "Campaigns",
        subtitle: "View Campaign Information",
        href: "/campaign",
      },
      {
        title: "Users",
        subtitle: "Manage Exxon's Users",
        href: "/organization-page/users",
      },
      {
        title: "Donors",
        subtitle: "View Donors",
        href: "/reports",
      },
      {
        title: "Employee Import",
        subtitle: "Employee Import",
        href: "/employee-upload",
      },
      {
        title: "Employees",
        subtitle: "Manage Employees",
        href: "/employees",
      },
    ],
  },
];

const OrganizationDashboard = () => {
  const userClaim = getClaims();

  return (
    <div style={{ height: "auto" }}>
      <Row>
        {groups.map((item: DashboardGroupProps) => (
          <>
            {(item.isDisplayed || item.isDisplayed === undefined) && (
              <DashboardGroup
                title={userClaim && userClaim["organization-name"]}
                items={item.items}
                isDisplayed={item.isDisplayed}
              />
            )}
          </>
        ))}
      </Row>
    </div>
  );
};

export default OrganizationDashboard;
